<template>
  <div id="seller">
    <div class="list">
      <div class="tabbar">
        <div id="tabbar">
          <div class="tabbarItem" :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index"
               @click="clickItem(item,index)">
            {{ item }}
          </div>
        </div>
        <div class="filter_search">
          <input type="text" v-model="match" class="filter_search_input" placeholder="请输入账户关键词">
          <span class="filter_search_btn" @click="clickMatch">确认</span>
        </div>
      </div>
      <div class="filter">
        <div class="select_ground">
          <div class="select_data">
            <el-select v-model="value" clearable :popper-append-to-body="false" placeholder="选择时间"
                       @change="selectTimeChange">
              <el-option
                v-for="(item,index) in options"
                :key="index.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select_game">
            <el-select v-model="selectGameValue" clearable :popper-append-to-body="false" placeholder="选择游戏"
                       @change="selectGameChange">
              <el-option
                v-for="(item,index) in selectGame"
                :key="index"
                :label="item.label"
                :value="{value:item.value,label:item.label}">
              </el-option>
            </el-select>
          </div>
          <div class="select_Pstatus">
            <el-select v-model="selectPStatusValue" clearable :popper-append-to-body="false" placeholder="选择商品状态"
                       @change="selectPStatusChange">
              <el-option
                v-for="(item,index) in selectPStatus"
                :key="index.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="select_status">
            <el-select v-model="selectStatusValue" clearable :popper-append-to-body="false" placeholder="降价请求状态"
                       @change="selectStatusChange">
              <el-option
                v-for="(item,index) in selectStatus"
                :key="index.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="product_list">
        <div v-if="listLoading" class="list_loading" v-loading="listLoading"></div>
        <div v-else-if="totalCount !== 0">
          <div class="delect" :style="!allcheckedShow?'justify-content:flex-end':'justify-content:space-between'">
            <el-checkbox v-model="allchecked" v-if="allcheckedShow" @change="checkboxChange">全选</el-checkbox>
            <div class="delBtn" v-if="!allcheckedShow" @click="allcheckedShow = true">
              <i class="el-icon-delete"></i>批量删除
            </div>
            <div class="delBtn" v-else>
              <span @click="delData">删除</span>
              <span @click="allcheckedShow = false">取消</span>
            </div>
          </div>
          <bargainItem :list="tableData" :allchecked-show="allcheckedShow" :selectItemIndex="selectItemIndex" :selectItem="selectItem" :api-bargain="apiBargain"
                       type="seller"></bargainItem>
          <div class="pages">
            <common-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="PageSize"
              layout="prev, pager, next, jumper"
              :total="totalCount">
            </common-pagination>
          </div>
        </div>
        <div class="no_data" v-else>
          <empty-state
            title="暂无降价请求"
            description="可以调整筛选条件后再次查看"
            icon="el-icon-price-tag"
            :icon-size="52">
          </empty-state>
        </div>
      </div>
    </div>
    <!--  还价确认框  -->
    <el-dialog
      :visible.sync="refuseDialog"
      custom-class="refuseDialog"
      :show-close="false"
      width="446px"
      top="35vh"
      center>
      <div id="refuseDialog">
        <div class="originalPrice">商品原价：{{ refuseData.price }}</div>
        <div class="offerAPrice">
          <i class="iconfont icon-price"></i>
          买家出价：{{ refuseData.bargain_price }}
        </div>
        <div class="counteroffer">
          卖家还价：
          <el-input
            type="number"
            placeholder="输入您的还价金额"
            v-model="counterofferInput"
            class="counterofferInput">
          </el-input>
        </div>
        <div class="btnGroup">
          <div class="btn" @click="bargainRefuse">确认修改</div>
        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="refuseDialog = false">
      </div>
    </el-dialog>
    <!--  确认拒绝框  -->
    <el-dialog
      :visible.sync="agreeDialog"
      custom-class="refuseDialog"
      :show-close="false"
      width="358px"
      top="35vh"
      center>
      <div id="agreeDialog">
        <div class="title">
          <i class="iconfont icon-price"></i>买家出价：{{ refuseData.bargain_price }}
        </div>
        <div class="text">
          是否确认{{ agreeDialogText }}该用户的出价？
        </div>
        <div class="btnGroup">
          <div class="btn" @click="agreeDialog = false">取消</div>
          <div class="btn" @click="bargainAgree">确认</div>
        </div>
        <img class="close" src="@/assets/image/AccountDeal/close.png" alt="" @click="agreeDialog = false">
      </div>
    </el-dialog>

  </div>
</template>
<script>
import {
  apiGameList,
  apiSellerReduRequest,
  apiSellerReduRequestEquip,
  apiBuyBargainStatus,
  apiProductPrice,
  apiProductEditinfo,
  apiProductAccount,
  apiBargainAdd,
  apiPremiumEdit,
  apiBuyBargainEquipStatus,
  apiBargainSaleDel
} from "@/request/API";


import bargainItem from "@/views/PersonalCenter/components/bargainItem";
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";

export default {
  name: '',
  props: {},
  components: {bargainItem, CommonPagination, EmptyState},
  data() {
    return {
      // 默认显示第几页
      currentPage: 1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount: 0,
      // 默认每页显示的条数（可修改）
      PageSize: 10,
      selectItem: '游戏账号',
      selectItemIndex: 0,
      //tabbar
      tabbarItem: [
        '游戏账号', '装备道具'
      ],
      //账号列表
      tableData: [],
      //列表加载状态
      listLoading: true,
      //选择时间下拉框
      options: [
        {value: '0', label: '全部'},
        {value: '1', label: '本周内'},
        {value: '2', label: '当月'},
        {value: '3', label: '三个月内'},
        {value: '4', label: '半年内'},
        {value: '5', label: '半年以上'},
        {value: '6', label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //选择商品状态下拉框
      selectPStatus: [
        {value: '1', label: '在售'},
        {value: '2', label: '已售'},
        {value: '3', label: '已下架'},
        {value: '6', label: '交易中'},
      ],
      selectPStatusValue: '',
      //选择请求状态下拉框
      selectStatus: [
        {value: '1', label: '卖家确认中'},
        {value: '2', label: '卖家同意'},
        {value: '3', label: '求降价失败'},
      ],
      selectStatusValue: '',
      //关键字搜索
      match: '',
      apiBargain: apiBuyBargainStatus,
      //批量删除
      allchecked: false,
      allcheckedShow: false,
      //拒绝还价弹出框
      refuseDialog: false,
      //拒绝还价数据
      refuseData: {},
      //还价金额
      counterofferInput: '',
      agreeDialog: false,
      agreeDialogText: ''
    }
  },
  methods: {
    tablaRowClick(row, column, event) {
      switch (this.selectItem) {
        case "游戏账号":
          this.$router.push({
            name: 'GameDetails',
            query: {
              game_id: row.game_id,
              id: row.product_id,
              source_page: this.$route.path.slice(1)
            }
          });
          break;
        case "装备道具":
          this.$router.push({
            name: 'EquipmentDetails',
            query: {
              game_id: row.game_id,
              id: row.product_id
            }
          });
          break;
      }
    },
    //tabbar
    clickItem(item, index) {
      this.currentPage = 1
      //获取游戏列表
      apiGameList({}).then(res => {
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      this.selectItem = item
      this.selectItemIndex = index
        this.selectPStatusValue = ''
      if (this.selectItem == '游戏账号') {
        this.apiBargain = apiBuyBargainStatus
        this.selectPStatus=  [
          {value: '1', label: '在售'},
          {value: '2', label: '已售'},
          {value: '3', label: '已下架'},
          {value: '6', label: '交易中'},
        ]
          this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.selectPStatus=  [
          {value: '2', label: '在售'},
          {value: '3', label: '已下架'},
        ]
        this.apiBargain = apiBuyBargainEquipStatus
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //table监听事件
    handleEditPrice(index, row) {
      const h = this.$createElement;
      this.$msgbox({
        title: '',
        message: h('div', {class: 'confirm_content'}, [
          h('div', {class: 'confirm_original_price'}, '当前价格：' + row.price + ''),
          h('div', {class: 'confirm_modify_bid'}, [
            h('div', {class: 'confirm_modify_bid_text'}, '修改出价：'),
            h('input', {
              class: 'confirm_modify_bid_input',
              attrs: {placeholder: "输入修改后的价格", id: "confirm_modify_bid_input"}
            }),
          ]),
        ]),
        confirmButtonText: '确认修改',
        confirmButtonClass: 'change_price_btn',
        customClass: 'change_price_seller',
        closeOnClickModal: false,
        showClose: true,
        callback: action => {
          if (action === "confirm") {
            apiProductPrice({
              id: row.id,
              game_id: row.game_id,
              price: document.getElementById("confirm_modify_bid_input").value
            }).then(res => {
              this.$message({
                message: '修改成功',
                center: true,
                type: 'success'
              })
              this.getDataList(this.value, this.selectGameValue.value, this.selectItemIndex, this.match)
            }).catch(err => {
              this.$message({
                message: err.msg,
                center: true,
                type: 'error'
              })
            })
          }
          document.getElementById("confirm_modify_bid_input").value = ''
        }
      });
    },

    handleEditAccount(index, row) {
      this.dialogFormVisible = true
      apiProductEditinfo({
        id: row.id,
        game_id: row.game_id
      }).then(res => {
        this.form.id = row.id
        this.form.game_id = row.game_id
        this.form.account = res.data.game_account
        this.form.pwd = res.data.game_pwd
        this.form.re_pwd = res.data.game_pwd
        this.form.se_pwd = res.data.game_second_pwd
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiProductAccount({
            id: this.form.id,
            game_id: this.form.game_id,
            game_account: this.form.account,
            game_pwd: this.form.pwd,
            game_second_pwd: this.form.se_pwd,
          }).then(res => {
            this.$message({
              type: "success",
              center: true,
              message: "修改成功"
            })
            this.dialogFormVisible = false
            this.getDataList(this.value, this.selectGameValue.value, this.selectItemIndex, this.match)
          }).catch(err => {
            this.$message({
              type: "error",
              center: true,
              message: err.msg
            })
          })
        }
      })
    },
    submitPForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          apiPremiumEdit({
            id: this.premiumSetForm.id,
            game_id: this.premiumSetForm.game_id,
            status: this.premiumSetForm.is_premium,
          }).then(res => {
            this.$message({
              type: "success",
              center: true,
              message: "修改成功"
            })
            this.premiumSet = false
            this.getDataList(this.value, this.selectGameValue.value, this.selectItemIndex, this.match)
          }).catch(err => {
            this.$message({
              type: "error",
              center: true,
              message: err.msg
            })
          })
        }
      })
    },

    //分页监听事件
    handleCurrentChange(val) {
      this.currentPage = val
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //降价同意确认
    agree_confirm(data, type) {
      this.agreeDialog = true
      this.refuseData = data
      this.agreeDialogText = type
    },
   async bargainAgree() {
      let status = this.agreeDialogText === '同意'?2:3
      await this.apiBargain({
        id: this.refuseData.id,
        status: status,
      }).then(res => {
        this.$message({
          type: 'success',
          center: true,
          message: `降价${this.agreeDialogText}成功`
        });
        if (this.selectItem == '游戏账号') {
          this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
        } else {
          this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          center: true,
          message: err.msg
        })
      })
     this.agreeDialog = false
    },
    //降价拒绝确认
    refuse_confirm(data) {
      this.refuseDialog = true
      this.refuseData = data
      this.counterofferInput = ''
    },
   async bargainRefuse(){
      if((this.counterofferInput+'').includes('.')) {
        this.$message({
          type: "error",
          message: '价格不支持小数',
          center: true
        })
        return
      }
     await this.apiBargain({
        id: this.refuseData.id,
        status: 3,
        sell_price:this.counterofferInput
      }).then(res => {
        this.$message({
          type: 'success',
          center: true,
          message: "还价成功"
        });
        if (this.selectItem == '游戏账号') {
          this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
        } else {
          this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
        }
      }).catch(err => {
        this.$message({
          type: 'error',
          center: true,
          message: err.msg
        })
      })
     this.refuseDialog = false
    },
    //游戏筛选 下拉框监听事件
    selectStatusChange(event) {
      this.currentPage = 1
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //游戏筛选 下拉框监听事件
    selectPStatusChange(event) {
      this.currentPage = 1
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //游戏筛选 下拉框监听事件
    selectGameChange(event) {
      this.currentPage = 1
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //时间筛选 下拉框监听事件
    selectTimeChange(value) {
      this.currentPage = 1
      this.value = value
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    //关键字搜索
    clickMatch() {
      this.currentPage = 1
      if (this.selectItem == '游戏账号') {
        this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
      } else {
        this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
      }
    },
    /**
     * 获取 游戏账号 收到的降价请求 列表
     * @param game_id 选择游戏 下拉框
     * @param type    选择时间 下拉框
     * @param match   关键字
     */
    getReduRequestList(type, game_id, match, page) {
      this.allchecked = false
      this.allcheckedShow = false
      this.listLoading = true
      apiSellerReduRequest({
        type: type,
        game_id: game_id,
        match: match,
        page: page,
        goodsStatus:this.selectPStatusValue,
        status:this.selectStatusValue,
      }).then(res => {
        this.totalCount = res.data.total
        this.tableData = res.data.list
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },

    /**
     * 获取 游戏装备 收到的降价请求 列表
     * @param game_id 选择游戏 下拉框
     * @param type    选择时间 下拉框
     * @param match   关键字
     */
    getReduRequestListEquip(type, game_id, match, page) {
      this.allchecked = false
      this.allcheckedShow = false
      this.listLoading = true
      apiSellerReduRequestEquip({
        type: type,
        game_id: game_id,
        match: match,
        page: page,
        goodsStatus:this.selectPStatusValue,
        status:this.selectStatusValue,
      }).then(res => {
        this.totalCount = res.data.total
        this.tableData = res.data.list
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    //初始化数据
    onLoad() {
      //获取游戏列表
      apiGameList({}).then(res => {
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          this.selectGame.push(options)
        })
      })
      //获取 账号列表
      this.listLoading = true
      apiSellerReduRequest({}).then(res => {
        this.totalCount = res.data.total
        this.tableData = res.data.list
        this.tableData.forEach((item, index) => {
          this.$set(this.tableData[index], "checkbox", false);
        })
      }).finally(() => {
        this.listLoading = false
      })
    },
    /**
     * 全选框change事件
     * @param value
     */
    checkboxChange(value) {
      this.tableData.forEach((item, index) => {
        item.checkbox = value
      })

    },
    /**
     * 取消全选
     */
    allCheckedCancel() {
      this.allchecked = false
    },
    /**
     * 删除数据
     */
    delData(){
      let ids = []
      this.tableData.forEach(item=>{
        if (item.checkbox) {
          ids.push(item.id)
        }
      })
      if(ids.length === 0){
        this.$message({
          type: 'error',
          center: true,
          message: '您还未选中任何商品～'
        })
      }else{
        apiBargainSaleDel({
          ids:ids
        }).then(res=>{
          this.$message({
            type: 'success',
            center: true,
            message: "删除成功"
          });
          if (this.selectItem == '游戏账号') {
            this.getReduRequestList(this.value, this.selectGameValue.value, this.match, this.currentPage)
          } else {
            this.getReduRequestListEquip(this.value, this.selectGameValue.value, this.match, this.currentPage)
          }
        })
      }

    }
  }
  ,
  mounted() {
    //初始化数据
    this.onLoad()
  }
  ,
  computed: {}
}
</script>
<!-- 弹框 -->
<style lang="less">
.agree_confirm {
  width: 386px !important;
  height: 232px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;

  .el-message-box__header, .el-message-box__content, .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 30px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }

  .agree_confirm_btn {
    margin-top: 36px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .agree_confirm_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }
}

.change_price_seller {
  width: 500px !important;
  height: 250px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }

  .change_price_btn {
    margin-top: 40px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_price_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price {
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FC4A00;
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }

  .confirm_modify_bid_input {
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}

.change_account {
  width: 500px !important;
  height: 250px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;

  .el-message-box__header > .el-message-box__title {
    display: none;
  }

  .el-message-box__header, .el-message-box__content {
    display: flex;
    flex-direction: column;
    padding: 0 0 0 70px;
  }

  .el-message-box__btns {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
  }

  .el-message-box__title {
    margin-top: 38px;
    font-size: 20px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #5B5B5B;
    line-height: 28px;
  }

  .el-message-box__container {
    margin-top: 34px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 22px;
  }

  .change_account_btn {
    margin-top: 40px;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 3px;
    border: none;
    font-size: 18px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 400;
    color: #FFFFFF !important;
  }

  .change_account_btn:hover {
    background: var(--primary-hover, #E84A12) !important;
  }

  .confirm_content {
    display: flex;
    flex-direction: column;
  }

  .modify_account {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 0 20px 0;
  }

  .modify_account_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }

  .modify_account_input {
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .modify_account_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }

  .modify_pwd {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .modify_pwd_text {
    font-size: 20px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #5B5B5B;
    line-height: 28px;
  }

  .modify_pwd_input {
    width: 210px;
    height: 40px;
    background: #F9F9F9;
    border-radius: 4px;
    border: 1px solid #F0F0F0;
    padding: 0 20px;
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    line-height: 22px;
  }

  .modify_pwd_input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Thin, PingFang SC;
    font-weight: 300;
    color: #D1D1D1;
  }
}

.sellPopconfirm {
  .el-popconfirm {
    .el-popconfirm__action {
      .el-button {
        span {
          color: var(--primary, #FF5A1F);
          font-family: PingFangSC-Light, PingFang SC;
        }
      }

      .el-button--productOff {
        border: none;
        background: var(--primary, #FF5A1F);

        span {
          color: #FFFFFF;
        }
      }
    }
  }
}


.refuseDialog {
  overflow: visible;
  border-radius: 4px;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-dialog__header, .el-dialog__body {
    padding: 0 !important;
  }

  #refuseDialog {
    position: relative;
    padding: 30px 42px 34px;
    display: flex;
    flex-direction: column;
    //align-items: center;
    .originalPrice {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      margin: 0 0 10px;
    }

    .offerAPrice {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--primary, #FF7A1A);
      display: flex;
      align-items: center;
      margin: 0 0 22px;

      i {
        margin: 0 6px 0 0;
      }
    }

    .counteroffer {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--text-main, #111827);
      display: flex;
      align-items: center;
      margin: 0 0 29px;

      .counterofferInput {
        width: 250px;

        .el-input__inner {
          height: 40px;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
        }

        .el-input__inner:focus {
          border-color: var(--primary, #FF5A1F);
          box-shadow: none;
        }
      }
    }

    .btnGroup {
      display: flex;
      justify-content: center;

      .btn {
        width: 290px;
        height: 40px;
        line-height: 40px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        transition: background .2s ease, opacity .2s ease;
      }

      .btn:hover {
        background: var(--primary-hover, #E84A12);
      }

    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }
  }

  #agreeDialog {
    position: relative;
    padding: 30px 34px 34px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Medium;
      font-weight: 500;
      color: var(--primary, #FF7A1A);
      display: flex;
      align-items: center;
      margin: 0 0 12px;

      i {
        margin: 0 7px 0 0;
      }
    }

    .text {
      font-size: 16px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      margin: 0 0 22px;
    }

    .btnGroup {
      display: flex;
      justify-content: center;

      .btn {
        width: 138px;
        height: 38px;
        line-height: 38px;
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: CENTER;
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        cursor: pointer;
        transition: background .2s ease, opacity .2s ease;
      }

      .btn:hover {
        background: var(--primary-hover, #E84A12);
      }

      .btn:first-of-type {
        border: 1.5px solid var(--bg-dark, #1A1D24);
        background: #FFFFFF;
        color: var(--text-main, #1A1D24);
        margin: 0 15px 0 0;
      }

      .btn:first-of-type:hover {
        background: #FFFFFF;
      }

    }

    .close {
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: calc(50% - 15px);
      cursor: pointer;
    }


  }
}
</style>
<style lang='less' scoped>
/deep/ .el-checkbox {
  display: flex;
  align-items: center;
}

/deep/ .el-checkbox__label {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: 500;
  color: #a5a5a5;
}

/deep/ .el-checkbox__inner {
  border-radius: 4px;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: var(--primary, #FF5A1F);
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: var(--primary, #FF5A1F);
  border-color: var(--primary, #FF5A1F);
}

/deep/ .el-checkbox__input.is-focus .el-checkbox__inner, /deep/ .el-checkbox__inner:hover, /deep/ .el-input__inner:focus {
  border-color: var(--primary, #FF5A1F);
}

/*在谷歌下移除input[number]的上下箭头*/
.el-input__inner[type="number"]::-webkit-outer-spin-button,
/deep/ .el-input__inner[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

/*在firefox下移除input[number]的上下箭头*/
.el-input__inner[type="number"] {
  -moz-appearance: textfield;
}

#seller {
  padding: 0;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }

  .list {
    min-height: 620px;
    padding: 20px;
  }

  .tabbar {
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    #tabbar {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
    }

    .tabbarItem {
      min-width: 86px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    .tabbarItem:hover {
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve,
    .isAcitve:hover {
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: inset 0 -3px 0 var(--primary, #FF5A1F);
    }

    .filter_search {
      width: 318px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input {
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder {
        font-size: 14px;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn {
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 3px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        transition: background .2s ease;
      }

      .filter_search_btn:hover {
        background: var(--primary-hover, #E84A12);
      }
    }
  }

  .filter {
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    align-items: center;
    background: transparent;
    border: none;

    .select_ground {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      gap: 12px;

      .select_data,
      .select_game,
      .select_status,
      .select_Pstatus {
        margin-right: 0;
      }

      /deep/.el-input__inner {
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus {
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow {
        left: 155px !important;
      }

      /deep/.el-select-dropdown {
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item {
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover {
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected {
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }
    }
  }

  .product_list {
    min-height: 300px;
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);
  }

  .delect {
    min-height: 54px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    background: var(--bg-tag, #F0EDE8);
    border-bottom: 1px solid var(--border-soft, #E8E4DE);

    .delBtn {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      line-height: 20px;
      color: var(--text-secondary, #5A5F6B);
      cursor: pointer;
      transition: color .2s ease;

      &:hover {
        color: var(--text-main, #1A1D24);
      }

      i {
        margin: 0 2px 0 0;
        color: inherit;
        font-size: 15px;
        font-weight: 600;
        line-height: 1;
      }

      span {
        height: 30px;
        padding: 0 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        background: var(--danger, #EF4444);
        cursor: pointer;
      }

      span:last-of-type {
        color: var(--text-secondary, #5A5F6B);
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
      }
    }
  }

  /deep/.el-checkbox__label {
    font-size: 14px;
    color: var(--text-secondary, #5A5F6B);
  }

  /deep/.el-checkbox__inner {
    border-radius: 4px;
    border-color: var(--border-strong, #CBD5E1);
  }

  /deep/.el-checkbox__input.is-checked + .el-checkbox__label {
    color: var(--primary, #FF5A1F);
  }

  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: var(--primary, #FF5A1F);
    border-color: var(--primary, #FF5A1F);
  }

  /deep/.el-checkbox__input.is-focus .el-checkbox__inner,
  /deep/.el-checkbox__inner:hover {
    border-color: var(--primary, #FF5A1F);
  }

  .pages {
    min-height: 88px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--bg-card, #FFFFFF);
  }

  .list_loading,
  .no_data {
    min-height: 300px;
    padding: 64px 36px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.bargainList {
    .bargainItem {
      height: 206px;
      padding: 0 0 0 18px;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      transition: background .2s ease;

      .img {
        margin-right: 18px;

        div {
          width: 164px;
          height: 164px;
          overflow: hidden;
          background: var(--bg-tag, #F0EDE8);
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
        }
      }

      .baseInfo {
        width: 392px;
        height: 164px;
        padding-right: 20px;
        border-right: 1px solid var(--border-soft, #E8E4DE);

        .number,
        .zone,
        .other,
        .time {
          font-size: 13px;
          color: var(--text-muted, #9AA0AC);
        }

        .name {
          font-size: 15px;
          font-weight: 500;
          color: var(--text-main, #111827);
          line-height: 24px;

          .status {
            display: inline-flex;
            align-items: center;
            height: 22px;
            padding: 0 8px;
            border-radius: 4px;
            background: var(--bg-tag, #F0EDE8);
            color: var(--text-main, #1A1D24);
            font-size: 12px;
          }
        }

        .price {
          .originalPrice {
            color: var(--text-secondary, #5A5F6B);

            div {
              color: var(--text-main, #111827);
              font-size: 18px;
            }
          }

          .quotedPrice {
            color: var(--primary, #FF7A1A);

            div {
              color: var(--primary, #FF7A1A);
              font-size: 20px;
            }
          }
        }
      }

      .operating {
        width: 272px;

        .status {
          color: var(--text-main, #111827);
          font-size: 15px;
        }

        .time {
          color: var(--text-muted, #9AA0AC);
          font-size: 13px;
        }

        .btnGroup {
          width: 100%;
        }

        .btnGroup > div {
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 6px;
          flex-wrap: wrap;

          .btn {
            height: 30px;
            min-width: 82px;
            padding: 0 12px;
            margin: 18px 0 0;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            line-height: 1;
            white-space: nowrap;
            background: var(--primary, #FF5A1F);
            border: 1px solid transparent;
            border-radius: 3px;
            color: #FFFFFF;
            font-size: 13px;
            transition: box-shadow .2s ease, opacity .2s ease, background .2s ease, color .2s ease, border-color .2s ease;
          }

          .btn:hover {
            background: var(--primary-hover, #E84A12);
          }

          .edit,
          .modify {
            background: var(--bg-card, #FFFFFF);
            border-color: var(--bg-dark, #1A1D24);
            color: var(--text-main, #1A1D24);

            span:hover {
              color: var(--text-main, #1A1D24);
            }
          }

          .edit:hover,
          .modify:hover {
            background: var(--bg-tag, #F0EDE8);
            box-shadow: none;
          }

          .edit {
            width: 104px;
            min-width: 104px;
          }

          .agree {
            width: 104px;
            min-width: 104px;
          }
        }
      }
    }

    .bargainItem:hover {
      background: var(--bg-tag, #F0EDE8);
    }
  }

  /deep/.el-dialog {
    border-radius: 4px;
  }

  /deep/.is-checked .el-radio__inner {
    border-color: var(--primary, #FF5A1F);
    background: var(--primary, #FF5A1F);
  }

  /deep/.el-radio.is-checked > .el-radio__label {
    color: var(--primary, #FF5A1F);
  }
}
</style>
